import { Injectable } from '@angular/core';
import { DispositionMailDraftApiService, DispositionMailDraftDto, DispositionMailDraftListItemDto } from '@api/api.service';
import { ApiResponseUtils } from '@core/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DispositionMailDraftService {
  constructor(private readonly api: DispositionMailDraftApiService) {}

  getAll(): Observable<DispositionMailDraftListItemDto[]> {
    return this.api.getAll().pipe(map(ApiResponseUtils.getDataFromResponse));
  }

  get(id: number): Observable<DispositionMailDraftDto> {
    return this.api.get(id).pipe(map(ApiResponseUtils.getDataFromResponse));
  }

  create(dto: DispositionMailDraftDto): Observable<DispositionMailDraftDto> {
    return this.api.create(dto).pipe(map(ApiResponseUtils.getDataFromResponse));
  }

  update(id: number, dto: DispositionMailDraftDto): Observable<DispositionMailDraftDto> {
    return this.api.update(id, dto).pipe(map(ApiResponseUtils.getDataFromResponse));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }

  send(id: number, dto: DispositionMailDraftDto): Observable<void> {
    return this.api.send(id, dto);
  }
}
